import {post, downFile} from './http'
const baseUrl = '/api'

// 交易管理-订单管理-订单导出
export const exportList = v => downFile(`${baseUrl}/admin/order/exportList`, v.data, v.success, v.error)
export const exportUserOrderList = v => downFile(`${baseUrl}/admin/order/exportUserOrderList`, v.data, v.success, v.error)

// 交易管理-财务管理-账单导出
export const exportOrdersList = v => downFile(`${baseUrl}/admin/order/exportOrdersList`, v.data, v.success, v.error)
// 交易管理-订单管理-查询订单列表
export const findAllList = v => post(`${baseUrl}/admin/order/findAllList`, v.data, v.success, v.error)
export const findOrderInfo = v => post(v.url, v.data, v.success, v.error)
// 交易管理-财务管理-获取账单列表
export const findBillToList = v => post(`${baseUrl}/admin/order/bill`, v.data, v.success, v.error)
// 交易管理-财务管理-查询收入 支出的数据
export const moneydirect = v => post(`${baseUrl}/admin/order/bill/moneydirect`, v.data, v.success, v.error)
// 交易管理-财务管理-获取账单详情
export const billInfo = v => post(`${baseUrl}/admin/order/bill/{productinnerid}`, v.data, v.success, v.error)
// 交易管理-财务管理-提现列表的分页查询
export const withdrawList = v => post(`${baseUrl}/admin/order/withdrawList`, v.data, v.success, v.error)
// 交易管理-财务管理-提现详情
export const withdrawListInfo = v => post(v.url, v.data, v.success, v.error)
// 交易管理-财务管理-账户余额
export const findHostMoney = v => post(`${baseUrl}/admin/order/findHostMoney`, v.data, v.success, v.error)
// 交易管理-获取提现信息V2
export const getHostCashInfo = v => post(`${baseUrl}/admin/order/getHostCashInfo`, v.data, v.success, v.error)
// 交易管理-提现
export const balanceTransfer = v => post(`${baseUrl}/admin/order/balanceTransfer`, v.data, v.success, v.error)
// 交易管理-提现V2
export const balanceTransferV2 = v => post(`${baseUrl}/admin/order/balanceTransferV2`, v.data, v.success, v.error)
// 订单账户--账户明细列表
export const findUserOrderList = v => post(`${baseUrl}/admin/order/findUserOrderList`, v.data, v.success, v.error)

// 素材库-素材库容量
export const getAllCapacity = v => post(`${baseUrl}/admin/material/getAllCapacity`, v.data, v.success, v.error)
// 素材库-新增合集
export const addCollection = v => post(`${baseUrl}/admin/material/catalog`, v.data, v.success, v.error)
// 素材库-获取合集列表
export const getColList = v => post(`${baseUrl}/admin/material/catalog/findAll`, v.data, v.success, v.error)
// 素材库-视频合集重命名
export const videoColReName = v => post(`${baseUrl}/admin/material/catalog/videoName`, v.data, v.success, v.error)
// 素材库-图片合集重命名
export const imgColReName = v => post(`${baseUrl}/admin/material/catalog/imageName`, v.data, v.success, v.error)
// 素材库-删除素材分类合集
export const delMaterialGroup = v => post(`${baseUrl}/admin/material/catalog/delete`, v.data, v.success, v.error)
// 素材库-全部素材-删除素材
export const wholedelete = v => post(`${baseUrl}/admin/material/wholedelete`, v.data, v.success, v.error)
// 素材库-素材分类-移除素材
export const delMaterial = v => post(`${baseUrl}/admin/material/remove`, v.data, v.success, v.error)
// 素材库-查询所有视频信息
export const findAllVideo = v => post(`${baseUrl}/admin/material/video`, v.data, v.success, v.error)
// 素材库-查询所有图片信息
export const findAllImage = v => post(`${baseUrl}/admin/material/image`, v.data, v.success, v.error)
// 素材库-查询分组图片信息
export const findGroupImage = v => post(`${baseUrl}/admin/material/image`, v.data, v.success, v.error)
// 素材库-查询分组视频信息
export const findGroupVideo = v => post(`${baseUrl}/admin/material/video`, v.data, v.success, v.error)
// 素材库-上传图片
export const uploadImage = v => post(`${baseUrl}/admin/material/uploadImage`, v.data, v.success, v.error)
// 素材库-上传视频
export const uploadVideo = v => post(`${baseUrl}/admin/material/uploadVideo`, v.data, v.success, v.error)
// 素材库-修改单个素材的图片名称
export const updateImageofName = v => post(`${baseUrl}/admin/material/catalog/updateImageofName`, v.data, v.success, v.error)
// 素材库-修改单个素材的视频名称
export const updateVideoName = v => post(`${baseUrl}/admin/material/catalog/updateVideoName`, v.data, v.success, v.error)
// 素材库-将图片素材加入分类
export const imgClassify = v => post(v.url, v.data, v.success, v.error)
// 素材库-将视频素材加入分类
export const videoClassify = v => post(v.url, v.data, v.success, v.error)
// 商品分组-商品分组列表查询
export const findAllGoodsGroup = v => post(`${baseUrl}/admin/gooddivision/findGooddivisioninfoList`, v.data, v.success, v.error)
// 商品分组-新增商品分组
export const addGoodsGroup = v => post(`${baseUrl}/admin/gooddivision/addGoodsGroup`, v.data, v.success, v.error)
// 商品分组-编辑商品分组
export const updateGoodsGroup = v => post(`${baseUrl}/admin/gooddivision/updateGoodsGroup`, v.data, v.success, v.error)
// 商品分组-删除商品分组
export const delGoodsGroup = v => post(`${baseUrl}/admin/gooddivision/updateGooddivisioninfoByStatus`, v.data, v.success, v.error)
// 商品分组-内容管理-单个分组信息
export const getAssetGroupInfo = v => post(`${baseUrl}/admin/gooddivision/getAssetGroupInfo`, v.data, v.success, v.error)
// 商品分组-内容管理-商品分组内的商品列表分页查询
export const findGoodsGroupInfo = v => post(`${baseUrl}/admin/gooddivision/getAssetPageListFromGoodGroup`, v.data, v.success, v.error)
// 商品分组-内容管理-商品分组内的商品列表分页查询
export const findGoodsList = v => post(`${baseUrl}/admin/gooddivision/getAssetListFromGoodGroupNotBeing`, v.data, v.success, v.error)
// 商品分组-内容管理-添加商品到商品分组
export const addGoods = v => post(`${baseUrl}/admin/gooddivision/addAssetIntoGoodsGroup`, v.data, v.success, v.error)
// 商品分组-内容管理-商品分组内的商品移出分组
export const removeGroup = v => post(`${baseUrl}/admin/gooddivision/deleteKmcAssetFromGoodGroup`, v.data, v.success, v.error)
// 商品分组-内容管理-商品分组内的商品添加排序
export const goodsSort = v => post(`${baseUrl}/admin/gooddivision/updateKmcAssetOrderIndexFromGoodGroup`, v.data, v.success, v.error)

// 数据中心
// 实时概况--(今日收入昨日收入)折线图
export const getIncomeBreakdownMap = v => post(`${baseUrl}/admin/datacenter/getIncomeBreakdownMap`, v.data, v.success, v.error)
// 实时概况--统计访客数 付费用户数 浏览量 支付订单数
export const getDataStatistics = v => post(`${baseUrl}/admin/datacenter/getDataStatistics`, v.data, v.success, v.error)
// 实时概况--运营视窗核心指标与指标趋势图
export const getCoreIndicators = v => post(`${baseUrl}/admin/datacenter/getCoreIndicators`, v.data, v.success, v.error)
// 实时概况--流量看板与流量趋势图
export const getTraffic = v => post(`${baseUrl}/admin/datacenter/getTrafficKanban`, v.data, v.success, v.error)
// 实时概况--转化看板
export const getConvert = v => post(`${baseUrl}/admin/datacenter/getConvertKanban`, v.data, v.success, v.error)
// 实时概况--商品看板
export const getCommodity = v => post(`${baseUrl}/admin/datacenter/getCommodityKanban`, v.data, v.success, v.error)
// 实时概况--用户看板--店铺用户
export const getShopUser = v => post(`${baseUrl}/admin/datacenter/getShopUser`, v.data, v.success, v.error)
// 实时概况--用户看板--店铺付费用户
export const getShopPayingUser = v => post(`${baseUrl}/admin/datacenter/getShopPayingUser`, v.data, v.success, v.error)
// 流量分析--流量趋势
export const getTrafficTrends = v => post(`${baseUrl}/admin/datacenter/getTrafficTrends`, v.data, v.success, v.error)
// 流量分析--流量趋势分页查询
export const getTrafficAnalysis = v => post(`${baseUrl}/admin/datacenter/getTrafficAnalysis`, v.data, v.success, v.error)
// 流量分析--流量趋势数据导出,不分页
export const trafficExport = v => downFile(`${baseUrl}/admin/datacenter/getTrafficAnalysisExport`, v.data, v.success, v.error)
// 交易分析--交易概况
export const getTradingData = v => post(`${baseUrl}/admin/datacenter/getTradingSituation`, v.data, v.success, v.error)
// 交易分析--交易构成
export const getTrading = v => post(`${baseUrl}/admin/datacenter/getTrading`, v.data, v.success, v.error)
// 交易分析--交易构成柱状图
export const getTradingBarChart = v => post(`${baseUrl}/admin/datacenter/getTradingBarChart`, v.data, v.success, v.error)
// 内容分析--头部商品总览
export const getContentData = v => post(`${baseUrl}/admin/datacenter/getContentData`, v.data, v.success, v.error)
// 内容分析--商品效果表格数据
export const getCommodityEffect = v => post(`${baseUrl}/admin/datacenter/getCommodityEffect`, v.data, v.success, v.error)
// 内容分析--内容详情--商品名称内容下拉框
export const getChooseContent = v => post(`${baseUrl}/admin/datacenter/getChooseContent`, v.data, v.success, v.error)
// 内容分析--内容详情--销售情况
export const getSalesStatus = v => post(`${baseUrl}/admin/datacenter/getSalesStatus`, v.data, v.success, v.error)
// 内容分析--内容详情--销售情况表格及分页
export const getSalesStatusPaging = v => post(`${baseUrl}/admin/datacenter/getSalesStatusPaging`, v.data, v.success, v.error)
// 内容分析--内容详情--使用说明
export const getInstruction = v => post(`${baseUrl}/admin/datacenter/getInstruction`, v.data, v.success, v.error)
// 内容分析--内容详情--使用说明表格及分页
export const getInstructionPaging = v => post(`${baseUrl}/admin/datacenter/getInstructionPaging`, v.data, v.success, v.error)
// 用户分析--用户概况及趋势
export const getUserData = v => post(`${baseUrl}/admin/datacenter/getUserProfile`, v.data, v.success, v.error)
// 交易分析--交易概况导出
export const getTradingSituationExport = v => downFile(`${baseUrl}/admin/datacenter/getTradingSituationExport`, v.data, v.success, v.error)
// 交易分析--交易构成导出
export const getTradingExport = v => downFile(`${baseUrl}/admin/datacenter/getTradingExport`, v.data, v.success, v.error)
// 用户分析--用户概况及趋势导出
export const getUserProfileExport = v => downFile(`${baseUrl}/admin/datacenter/getUserProfileExport`, v.data, v.success, v.error)
// 内容分析--商品效果导出
export const getContentList = v => downFile(`${baseUrl}/admin/datacenter/getContentList`, v.data, v.success, v.error)
// 内容分析--内容详情--销售情况导出
export const getSalesProfileExport = v => downFile(`${baseUrl}/admin/datacenter/getSalesProfileExport`, v.data, v.success, v.error)
// 内容分析--内容详情--使用说明导出
export const getInstructionProfileExport = v => downFile(`${baseUrl}/admin/datacenter/getInstructionProfileExport`, v.data, v.success, v.error)
